module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-400-[102]223.d995d69.woff2";